import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FooterComponent } from "./components/footer/footer.component";
import { NavComponent } from "./components/nav/nav.component";
import { MatSidenavModule} from '@angular/material/sidenav';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [FooterComponent, NavComponent, MatSidenavModule, CommonModule, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  constructor(private router: Router) {}

  isLoginOrCallbackRoute(): boolean {
    return this.router.url === '/edutec2-frontend/login' || this.router.url.startsWith('/edutec2-frontend/oauth');
  }
}
